<script setup lang="ts">
import { type DeviceModel } from '@/types/models/DeviceModel'
import { TooltipItem } from '@rfc/rfc-components-library'
import { EPosition } from '@rfc/rfc-components-library/types'
import DeviceUnavailabilityTitleTypography from './DeviceUnavailabilityTitleTypography.vue'
import DeviceUnavailabilityTooltip from './DeviceUnavailabilityTooltip.vue'

type Props = {
    data: Partial<DeviceModel>
}
defineProps<Props>()
</script>

<template>
    <TooltipItem
        v-if="data.unavailability_periods?.periods?.length"
        :position="EPosition.TOP"
        class="unavailabity-tooltip fit-content">
        <template #default="props">
            <DeviceUnavailabilityTitleTypography v-bind="props" />
        </template>
        <template v-if="data?.unavailability_periods?.periods" #content>
            <DeviceUnavailabilityTooltip :periods="data?.unavailability_periods?.periods" />
        </template>
    </TooltipItem>
</template>

<style scoped lang="scss">
/* .unavailabity-tooltip {
    z-index: 10;
} */

.incoming-rentals {
    padding: 2px;
    padding-right: 8px;
    border: 1px solid $primary;
    border-radius: 8px;
}
</style>
